import '../../../styles/src/05-components/blog-roll/style.scss';

// Quickmenu
import QuickMenu from "quickmenu";

document.addEventListener("DOMContentLoaded", () => {

    // Get current date and set on Date Input
    let today = new Date().toISOString().slice(0, 10);
    if (document.querySelector('#filterDate')) {
        document.querySelector('#filterDate').value = today;
    }

    // Post category archive controller
    if (document.querySelector('.blog-roll')) {

        new QuickMenu();

        let archiveSelect = document.getElementById('blog-roll-archive-select');
        const archiveButton = document.getElementById('blog-roll-archive');
        archiveButton.addEventListener('click', function(event) {
            event.preventDefault();

            // Ignore empty values
            if (archiveSelect.value == "") {
                return;
            } else {
                window.location.href = archiveSelect.value;
            }
        });

        // Get query data for initial posts
        let filterCategories = document.querySelector('.blog-roll__wrapper').dataset.categories;
        let initialPosts = '';
        let fetchUrl = window.location.protocol + '//' + window.location.hostname;
        if( window.location.port !== '' ) {
            fetchUrl += ':' + window.location.port;
        }
        fetchUrl += '/wp-json/wp/v2/posts?more_per_page=9999&categories=' + filterCategories;
        fetch( fetchUrl + '&_fields=id').then((response) => response.json()).then((posts) => {
            let postArray = []
            for( const post in posts ) {
                postArray.push( posts[post].id );
            }
            initialPosts = postArray.join();
        });

        // Set the results container and initial values
        let resultsContainer = document.querySelector('.blog-roll__link-container');
        let resultsLoader = document.querySelector('.blog-roll__loader');
        resultsLoader.style = "";
        const initialResults = resultsContainer.innerHTML;
        let filterDate = document.getElementById('filterDate').value;
        let filterKeyword = document.getElementById('filterKeyword').value;

        // Grab the default post image
        const defaultThumbnail = document.querySelector('.blog-roll__wrapper').dataset.thumbnail;

        // Form to control filter results
        const filterButton = document.getElementById('filterButton');
        filterButton.addEventListener('click', function(event) {
            event.preventDefault();

            // Reset fetch URL
            fetchUrl = window.location.protocol + '//' + window.location.hostname;
            if( window.location.port !== '' ) {
                fetchUrl += ':' + window.location.port;
            }
            fetchUrl += '/wp-json/wp/v2/posts?per_page=5&categories=' + filterCategories;

            filterDate = document.getElementById('filterDate').value;
            filterKeyword = document.getElementById('filterKeyword').value;

            // Fetch posts from the data provided, limited to data afterward
            if( filterDate !== '' ) {
                fetchUrl += '&order=asc&after=' + filterDate + "T00:00:00";
                if( filterKeyword !== '' ) {
                    fetchUrl += '&search=' + filterKeyword;
                }
            } else {
                if( filterKeyword !== '' ) {
                    fetchUrl += '&order=desc&search=' + filterKeyword;
                }
            }
            fetchUrl += '&include=' + initialPosts;
            fetchUrl += '&orderby=modified&_fields=link,date,title,excerpt,categories,featured_media';

            // If both fields are empty, skip the rest
            if (filterDate == '' && filterKeyword == '') {
                resultsContainer.innerHTML = initialResults;
            } else {
                // Build the results list
                fetch(fetchUrl).then((response) => response.json()).then((posts) => {
                    resultsContainer.classList.add( 'is-loading' );
                    resultsLoader.classList.add( 'is-visible' );
                    resultsContainer.innerHTML = "";
                    for( const post in posts ) {
                        setUpPost( posts[post], resultsContainer, defaultThumbnail );
                    }
                });
            }
        });

        // Results view controller
        const viewIcons = document.querySelectorAll('.blog-roll__view-icon');
        viewIcons.forEach(function(element) {
            element.addEventListener('click', function() {
                let modifier = element.dataset.value;

                // Ignore if the value is already applied
                if (resultsContainer.dataset.layout == modifier) {
                    return;
                } else {
                    resultsContainer.dataset.layout = modifier;
                    resultsContainer.className = 'blog-roll__link-container blog-roll__link-container--' + modifier;
                }
            });
        });

    }

});

/**
 * Sets up blog roll data for a post
 * @param string post
 */
let setUpPost = async (post, container, defaultThumbnail) => {
    // Set up fetch URL
    let fetchUrl = window.location.protocol + '//' + window.location.hostname;
    if( window.location.port !== '' ) {
        fetchUrl += ':' + window.location.port;
    }

    // Set up fetches
    let fetchCats = await fetch( fetchUrl + '/wp-json/wp/v2/categories' + '?include=' + post.categories.join(', ') );
    let categoriesJSON = await fetchCats.json();
    let fetchMedia;
    if( post.featured_media == 0 ) {
        fetchMedia = await fetch( fetchUrl + '/wp-json/wp/v2/media/' + defaultThumbnail );
    } else {
        fetchMedia = await fetch( fetchUrl + '/wp-json/wp/v2/media/' + post.featured_media );
    }
    let featuredImageJSON = await fetchMedia.json();

    Promise.all([categoriesJSON, featuredImageJSON ]).then((values) => {

        // Grab values from post
        let link = post.link;
        let date = new Date( post.date ).toLocaleDateString('en-us', {year:"numeric", month:"long", day:"numeric"});
        let title = post.title.rendered;
        let excerpt = post.excerpt.rendered;

        // Set up categories
        let categories = [];
        values[0].forEach( cat => {
            let category = new Object();
            category.url = cat.link;
            category.name = cat.name;
            categories.push(category);
        });
        let categoryCode = '<ul class="blog-roll__link-categories">';
        categories.forEach( category => {
            categoryCode += `<li><a href="${category.url}">${category.name}</a></li>\n`;
        });
        categoryCode += '</ul>';


        // Set up media
        let featuredImage = new Object();
        featuredImage.alt = values[1].alt_text ? values[1].alt_text : title;
        featuredImage.src = (typeof(values[1].media_details) != 'undefined') ? values[1].media_details.sizes['480w'].source_url : defaultThumbnail;

        container.innerHTML += `<div class="blog-roll__link-item"><a class="blog-roll__link blog-roll__link--image" href="${link}"><img class="blog-roll__link-image" src="${featuredImage.src}" alt="${featuredImage.alt}" /></a><div class="blog-roll__link-content">${categoryCode}<a class="blog-roll__link blog-roll__link--masthead" href="${link}"><h3 class="blog-roll__link-heading">${title}</h3><span class="blog-roll__link-date">${date}</span></a><div class="blog-roll__link-body">${excerpt}</div></div></div>`;
        document.querySelector('.blog-roll__loader').classList.remove( 'is-visible' );
    })
    .catch((error) => {
        // eslint-disable-next-line no-console
        console.error('Error:', error);
    });
}
